import * as yup from 'yup';

export const initialValues = {
  type_id: '',
  celebrate_name: '',
  gifttable_date: '',
  //email: '',
  gifttable_id: '',
  //customerSearsId: '',
};

export const schema = yup.object().shape({
  type_id: yup.string(),
  celebrate_name: yup.string(),
  gifttable_date: yup.string(),
  //email: yup.string(),
  gifttable_id: yup.string(),
});
